var React = require('react');

function EyeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.60195 14.957C8.22336 9.78562 12.356 7.19995 15.9999 7.19995C19.6439 7.19995 23.7765 9.7856 28.3979 14.9569L28.3979 14.9569C28.9339 15.5566 28.934 16.4431 28.3979 17.0429C23.7765 22.2143 19.6439 24.8 15.9999 24.8C12.356 24.8 8.22339 22.2143 3.60201 17.043L3.60196 17.043C3.06595 16.4433 3.06595 15.5568 3.60195 14.957ZM15.9999 19.2C17.8372 19.2 19.3267 17.7673 19.3267 16C19.3267 14.2326 17.8372 12.8 15.9999 12.8C14.1627 12.8 12.6732 14.2326 12.6732 16C12.6732 17.7673 14.1627 19.2 15.9999 19.2Z","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

EyeInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = EyeInline;

EyeInline.default = EyeInline;
